var exports = {
  "uu": "VoiceLobbyShared.module__actionButtons___alA3bj",
  "hP": "VoiceLobbyShared.module__actionButton___alA3bj",
  "zc": "VoiceLobbyShared.module__iconContainer___alA3bj",
  "KA": "VoiceLobbyShared.module__iconContainerBrand___alA3bj",
  "cF": "VoiceLobbyShared.module__iconContainerDanger___alA3bj",
  "hO": "VoiceLobbyShared.module__iconContainerTertiary___alA3bj",
  "cY": "VoiceLobbyShared.module__iconContainerSuccess___alA3bj",
  "gE": "VoiceLobbyShared.module__actionIcon___alA3bj",
  "uI": "VoiceLobbyShared.module__actionIconSecondary___alA3bj",
  "K2": "VoiceLobbyShared.module__actionText___alA3bj",
  "Hd": "VoiceLobbyShared.module__connectionInfo___alA3bj",
  "Il": "VoiceLobbyShared.module__connectionHeader___alA3bj",
  "p1": "VoiceLobbyShared.module__connectionStatusInfo___alA3bj",
  "bn": "VoiceLobbyShared.module__connectionTitle___alA3bj",
  "fV": "VoiceLobbyShared.module__connectionSubtitle___alA3bj",
  "Cb": "VoiceLobbyShared.module__connectionStatusDot___alA3bj",
  "wL": "VoiceLobbyShared.module__statsGrid___alA3bj",
  "N8": "VoiceLobbyShared.module__statRow___alA3bj",
  "Zh": "VoiceLobbyShared.module__statLabel___alA3bj",
  "cR": "VoiceLobbyShared.module__statValue___alA3bj",
  "_x": "VoiceLobbyShared.module__statValuePrimary___alA3bj",
  "V4": "VoiceLobbyShared.module__endpointValue___alA3bj",
  "TR": "VoiceLobbyShared.module__connectionIdValue___alA3bj",
  "JX": "VoiceLobbyShared.module__maxWidth___alA3bj",
};

module.exports = exports;
